<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="WEmployeeModal"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="employee"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <UcEmployeeFieldset
        :employee="editor"
      >
      </UcEmployeeFieldset>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.employee"
      :text="'Save'|gettext"
      type="submit"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class WEmployeeModal extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  parent!: object;

  @Watch('parent')
  onParent(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parent")
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  resource!: any;

  async $$load_resource() {
    return this.item || this.$fn.schemaDefaults('CreateEmployee')
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  createTitle!: any;
  editTitle!: any;
  ux!: any;
  dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        resource: null,
        editor: null,
        createTitle: this.$fn.pgettext("Employeees", "Add employee"),
        editTitle: this.$fn.pgettext("Employeees", "Edit employee"),
        ux: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.employeeId == null ? this.createTitle : this.editTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8318_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8318, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_8324_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_8324, alias=undefined
    return {
      result: {
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_closeComponent_8326_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_8326, alias=undefined
    return {
      result: {
      }
      ,
    }
  }

  async act_1040167445267876_rest_8322_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_8322, alias=submit
    return {
      method: "save",
      container: this.parent.employees,
      resource: this.editor,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8318: actions.CloseModalAction;
    evh_7315092382398562_close_8317: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8320: actions.CloseComponentAction;
    evh_2248226175642056_close_8319: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_8324: actions.CloseComponentAction;
    evh_1040167445267876_saved_8323: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_8326: actions.CloseComponentAction;
    evh_1040167445267876_deleted_8325: actions.EventHandlerImpl;
    act_1040167445267876_rest_8322: actions.RestAction;
    evh_1040167445267876_submit_8321: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_8328: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_8327: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8318 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8318_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8317 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8318,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8317],
      }
    );
    const act_2248226175642056_closeComponent_8320 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8319 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8320,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8319],
      }
    );
    const act_1040167445267876_closeComponent_8324 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_8324_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_8323 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_8324,
        event: "saved",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_closeComponent_8326 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_8326_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_deleted_8325 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_8326,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_rest_8322 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_8322_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_saved_8323, evh_1040167445267876_deleted_8325],
      }
    );
    const evh_1040167445267876_submit_8321 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_8322,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8321],
      }
    );
    const act_1419464017721962_closeComponent_8328 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_8327 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_8328,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8327],
      }
    );
    return {
      act_7315092382398562_closeModal_8318,
      evh_7315092382398562_close_8317,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8320,
      evh_2248226175642056_close_8319,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_8324,
      evh_1040167445267876_saved_8323,
      act_1040167445267876_closeComponent_8326,
      evh_1040167445267876_deleted_8325,
      act_1040167445267876_rest_8322,
      evh_1040167445267876_submit_8321,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_8328,
      evh_1419464017721962_clickPreventStop_8327,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_rest_8322,
    }
  }
}

Vue.component("WEmployeeModal", WEmployeeModal);

</script>